import { createContext } from "react";
export const designFourPagecounter = createContext(null);
export const designFourMainCategories = createContext([]);
export const designFourFavoriteInputsArray = createContext([]);
export const designFourWishlistItemsArray = createContext([]);